// src/constants/routes.js

export const ROUTES = {
  HOME: '/',
  SERVICES: '/services',
  SERVICE_DETAILS: '/services/:serviceType',
  CONTACT: '/contact',
  CONTACT_ID: '/contact/:id',
  CONTACT_ID_PID: '/contact/:id/:pId',
  PRODUCTS: '/products',
  PRODUCTS_CATEGORY: '/products/:cId',
  PRODUCTS_DETAILS: '/products/:cId/:pId',
  SANDBOX: '/sandbox',
  CHECKOUT: '/checkout',
};
